import { EtaResponseRouteItem } from '@bringg-frontend/eta-calculator';
import moment from 'moment/moment';

import { NO_ROUTE_ID } from '../../stores/routes-planner-store';
import { RoutesPlannerRun, RoutesPlannerTask } from '../../types/routes-planner-run';

const assignedTasksCount = (runToTasks: { [runId: number]: RoutesPlannerTask[] }, runsToDisplay: number[]) => {
	let totalTasksCount = 0;

	Object.entries(runToTasks).forEach(runToTask => {
		const runId = Number(runToTask[0]);
		if (runsToDisplay.includes(runId)) {
			const tasks = runToTask[1];
			totalTasksCount += tasks.length;
		}
	});
	return totalTasksCount;
};

const unassignedTasksCount = (runToTasks: { [runId: number]: RoutesPlannerTask[] }) => {
	return runToTasks[NO_ROUTE_ID]?.length || 0;
};

const assignedRoutes = (routes: RoutesPlannerRun[], runsToDisplay: number[]) => {
	return routes.filter(run => run.id !== NO_ROUTE_ID && runsToDisplay.includes(run.id));
};

const totalRoutesDuration = (
	routeInfoByIndex: { [runId: number]: EtaResponseRouteItem },
	routes: RoutesPlannerRun[],
	runsToDisplay: number[],
	isOriginal: boolean
) => {
	let totalDuration = 0;
	assignedRoutes(routes, runsToDisplay).forEach((route: RoutesPlannerRun) => {
		totalDuration += routeDuration(routeInfoByIndex, route, isOriginal);
	});
	return totalDuration;
};

const routeDuration = (
	routeInfoByIndex: {
		[runId: number]: EtaResponseRouteItem;
	},
	route: RoutesPlannerRun,
	isOriginal: boolean
) => {
	const routeInfo = isOriginal ? route : routeInfoByIndex[route.route_idx];
	const runStartTime = routeInfo?.depot_etl || route.depot_etl;
	const runEndTime = routeInfo?.depot_back_eta || route.depot_back_eta;

	return moment.duration(moment(runEndTime * 1000).diff(moment(runStartTime * 1000))).asMilliseconds();
};

const totalRoutesDistance = (
	routeInfoByIndex: { [runId: number]: EtaResponseRouteItem },
	routes: RoutesPlannerRun[],
	runsToDisplay: number[],
	isOriginal: boolean
) => {
	let totalDistance = 0;
	assignedRoutes(routes, runsToDisplay).forEach((route: RoutesPlannerRun) => {
		totalDistance += routeDistance(routeInfoByIndex, route, isOriginal);
	});
	return totalDistance;
};

const routeDistance = (
	routeInfoByIndex: {
		[runId: number]: EtaResponseRouteItem;
	},
	route: RoutesPlannerRun,
	isOriginal: boolean
) => {
	const routeInfo = isOriginal ? route : routeInfoByIndex[route.route_idx];
	return routeInfo ? routeInfo.transport_distance : route.transport_distance;
};

const stopsPerHour = (
	routeInfoByIndex: { [runId: number]: EtaResponseRouteItem },
	runToTasks: { [runId: number]: RoutesPlannerTask[] },
	routes: RoutesPlannerRun[],
	runsToDisplay: number[],
	routesById: Record<string, RoutesPlannerRun>,
	isOriginal: boolean
) => {
	let totalStopsPerHour = 0;
	Object.keys(runToTasks)
		.filter(runId => runId !== NO_ROUTE_ID.toString() && runsToDisplay.includes(Number(runId)))
		.forEach((runId: string) => {
			const tasks = runToTasks[Number(runId)];
			const run = routesById[runId];
			const transportTimeInHours = routeDuration(routeInfoByIndex, run, isOriginal) / 3600000;
			const stopsPerHour = tasks.length / transportTimeInHours;
			totalStopsPerHour += stopsPerHour;
		});
	const assignedRoutesCount = assignedRoutes(routes, runsToDisplay).length;
	return assignedRoutesCount !== 0 ? Number((totalStopsPerHour / assignedRoutesCount).toFixed(2)) : 0;
};

export const optimizationKpiDataService = {
	assignedTasksCount,
	unassignedTasksCount,
	assignedRoutes,
	totalRoutesDuration,
	totalRoutesDistance,
	stopsPerHour
};
